export enum SkeletonLoaderType {
  PROFILE,
  LINE,
  COLUMN,
}
